<template>
  <div>
    <b-modal
      :ok-only="true"
      style="padding:15px"
      size="lg"
      id="InvoiceShipmentsModal"
      ref="modal"
      title="Invoice Details"
    >
      <form ref="AddShipmentGovtForm">
        <b-card>
          <table
            class="table table-striped table-borderless cutom-table table-grey table-striped table-sm"
            style="font-size: 85%;"
          >
            <thead>
              <tr>
                <th role="columnheader">Date</th>
                <th role="columnheader">Client</th>
                <th role="columnheader">Voucher</th>
                <th role="columnheader">Flour</th>
                <th role="columnheader">Flour Weight</th>
                <th role="columnheader">No Of Sacks</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="shipmentDetails == null">
                <td class="center-td" colspan="6">No Items Added</td>
              </tr>

              <tr v-else v-for="entry in shipmentDetails" :key="entry.id">
                <td role="cell">
                  {{ entry.shipmentDate | moment("MMMM Do YYYY") }}
                </td>
                <td role="cell">{{ entry.client.companyName }}</td>
                <td role="cell">{{ entry.voucherNo }}</td>
                <td role="cell">
                  {{ entry.flourTypeWeightLink.flourType.name }}
                </td>

                <td role="cell">
                  {{ entry.flourTypeWeightLink.flourWeight.weight }}
                </td>

                <td>{{ entry.noOfSacks }}</td>
              </tr>
            </tbody>
          </table>
          <div class="text-center">
            <b-spinner v-if="isLoading" label="Loading..."></b-spinner>
          </div>
        </b-card>
      </form>
    </b-modal>
    <Toaster ref="toaster" />
  </div>
</template>

<script>
import Toaster from "../../toaster";
export default {
  name: "AddShipmentGovt",
  components: {
    Toaster,
  },
  data() {
    return {
      moduleName: "Shipment Details",
      isLoading: false,
      // props: ['shipmentDetails'],
    };
  },
  props:{
      shipmentDetails:{
          type : Array,
          default: null
      },
  },

  methods: {},
};
</script>
